import InformationCircleIcon from "@heroicons/react/24/solid/InformationCircleIcon";
import LinkIcon from "@mui/icons-material/Link";
import { Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../../../assets/colors";

export const DivStyled = styling(Grid)((props) => ({
  //
}));

export const ImageStyled = styling("img")((props) => ({
  objectFit: "cover",
  borderRadius: "8px",
  marginRight: "20px",
}));

export const TypographyStyled = styling(Typography)((props) => ({
  //
}));

export const NextLinkStyled = styling(Link)((props) => ({
  pointerEvents: props["aria-disabled"] ? "none" : "auto",
  textDecoration: props["aria-disabled"] ? "none" : "underline",
  textDecorationColor: Color.hiredlyPurple,
  width: "fit-content",
}));

export const LinkIconStyled = styling(LinkIcon)({
  width: "24px",
  height: "24px",
  color: Color.white,
});

export const StyledTooltip = styling(Tooltip)({
  display: "flex",
  padding: "2px 8px",
  justifyContent: "center",
  gap: "4px",
  alignItems: "center",
  borderRadius: "50px",
  background: "rgba(242, 175, 41, 0.30)",
  height: "fit-content",
  width: "fit-content",
});

export const StyledTooltipText = styling(Typography)({
  color: "rgba(0, 0, 0, 0.87)",
  fontFamily: "Inter",
  fontSize: "10px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "1.5px",
  textTransform: "uppercase",

  textWrap: "nowrap",
});

export const TooltipInfoText = styling(Typography)({
  alignSelf: "stretch",
  color: "#000000DE",
  fontFamily: "Inter",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
});

export const InfoCirleFilledStyled = styling(InformationCircleIcon)({
  margin: "2px",
  width: "10px",
  height: "10px",
});
